export default __webpack_public_path__ + "static/media/pensil.ceda5c0f.svg";